/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/15/20
Engine Hours component: called in irrigation_form
**********************************************************/
import { NumberInput } from '../../components/inputs';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  meters: PropTypes.array,
  calculateTotalMeterGallons: PropTypes.func,
  handleMeterGallons: PropTypes.func
};

const MeterGallons = ({ meters, calculateTotalMeterGallons, handleMeterGallons, edit }) => {
  return (
    <div>
      <div className="card z-depth-2">
        <div className="card-content">
          <span className="card-title blue-text"><u>Meter Gallons</u></span>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Meter</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Starting Gallons</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Ending Gallons</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Total</label>
              </div>
            </div>
            <div className="col s12 m6 l6 xl6 hide-on-small-only">
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Meter</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Starting Gallons</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Ending Gallons</label>
              </div>
              <div className="col s3 m3 l3 xl3">
                <label className="meter-label">Total</label>
              </div>
            </div>
          </div>
          <div className="row">
            {
              meters.map((m) => (
                <div key={m.id} className="col s12 m6 l6 xl6">
                  <div className="col s3 m3 l3 xl3">
                    <span className="irr-meter-label z-depth-3">{ m.meterNo }</span>
                  </div>
                  <div className="col s3 m3 l3 xl3">
                    <NumberInput id={`meter${m.id}-startGal`} name={`meter-${m.id}`} min={0} max={1000000000} />
                  </div>
                  <div className="col s3 m3 l3 xl3">
                    <NumberInput id={`meter${m.id}-endGal`} name={`meter-${m.id}`} min={0} max={1000000000} 
                      onChange={(e) => { calculateTotalMeterGallons({
                        startGal: document.getElementById(`meter${m.id}-startGal`).value,
                        endGal: e.target.value,
                        totalGalDOM: document.getElementById(`meter${m.id}-totalGal`)
                      });
                      handleMeterGallons({ 
                        m: {
                          meterId: m.id,
                          engineId: m.engineId,
                          startGal: document.getElementById(`meter${m.id}-startGal`).value,
                          endGal: e.target.value,
                          totalGal: document.getElementById(`meter${m.id}-totalGal`).value
                        },
                        edit
                      });
                    }}
                    />
                  </div>
                  <div className="col s3 m3 l3 xl3">
                    <NumberInput id={`meter${m.id}-totalGal`} defaultValue={0} disabled={true} />
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}


MeterGallons.propTypes = propTypes;
export default MeterGallons;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/irrigation_meter_gallons.js